
import Vue from "vue";
import AppErrorMessage from "@/components/common/ErrorMessageBox.vue";
import { AuthSocketService } from "@/services/auth-socket-service";
import { QrLoginService } from "@/services/qr-login-service";
import { HttpError } from "@/utils/services/http-error";

export default Vue.extend({
	data(){
		return {
			image: "",
			secondsLeft: 0,
			errorMessage: "",
			loading: false,
			interval: 0
		};
	},
	computed: {
		isVisible():boolean{
			return this.image != "";
		},
		countdown():string{
			let minutes = Math.floor(this.secondsLeft / 60);
			let seconds = this.secondsLeft % 60;
			return `${minutes}:${seconds.toString().padStart(2, "0")}`;
		}
	},
	methods: {
		async showCode(){
			if (this.loading) return;
			this.loading = true;
			this.errorMessage = "";
			try{
				let result = await QrLoginService.createCode();
				this.image = result.Image;
				this.startCountdown();
			}catch(err){
				let error = err as HttpError;
				error.dontShow = true;
				this.errorMessage = error.getText();
			}finally{
				this.loading = false;
			}
		},
		startCountdown(){
			this.stopCountdown();
			this.secondsLeft = QrLoginService.VISIBLE_SECONDS;
			this.interval = window.setInterval(()=>{
				this.secondsLeft--;
				if (this.secondsLeft <= 0){
					this.hideCode();
				}
			}, 1000);
		},
		stopCountdown(){
			if (!this.interval) return;
			window.clearInterval(this.interval);
			this.interval = 0;
		},
		hideCode(){
			this.stopCountdown();
			this.image = "";
			this.secondsLeft = 0;
		},
		onCodeUsed(data:any){
			this.hideCode();
			let device = (data && data.DeviceName) || this.$ct("qr-login-unknown-device").toString();
			this.$wf.notify(this.$ct("qr-login-device-logged-in", {device}).toString(), "success", 5000, "check");
		}
	},
	created(){
		AuthSocketService.on("/qr-login/used", this.onCodeUsed);
	},
	destroyed(){
		AuthSocketService.off("/qr-login/used", this.onCodeUsed);
		this.hideCode();
	},
	components: {
		AppErrorMessage
	},
	i18nEx: {
		componentPrefix: "components.account"
	}
});
